import {register} from '../vendor/theme-scripts/theme-sections';
import drawer from '../features/header-mobile-drawer';
import {cartDrawer} from '../features/cart-items';
import {accordion} from '../features/accordion';

register('cart-drawer', [drawer, cartDrawer, accordion]);
